exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3TkQx-7WZjY_dF4XozwL41{display:inline-block;width:6px;min-width:6px;vertical-align:middle;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}html[dir=ltr] ._3TkQx-7WZjY_dF4XozwL41{border-top-left-radius:2px;border-bottom-left-radius:2px}html[dir=rtl] ._3TkQx-7WZjY_dF4XozwL41{border-top-right-radius:2px;border-bottom-right-radius:2px}", ""]);
// Exports
exports.locals = {
	"bar": "_3TkQx-7WZjY_dF4XozwL41"
};